import ApolloClient from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createUploadLink } from 'apollo-upload-client';
import { onError } from 'apollo-link-error';
import { ApolloLink } from 'apollo-link';
import { withClientState } from 'apollo-link-state';

export const appCache = new InMemoryCache();

const errorLink = onError(({ graphQLErrors }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ type }) => {
      if (type === 'UNAUTHENTICATED') {
        appCache.writeData({
          data: {
            authStatus: {
              __typename: 'authStatus',
              status: 'loggedOut',
            },
          },
        });

        return;
      }

      if (type === 'UNAUTHORIZED') {
        appCache.writeData({
          data: {
            authStatus: {
              __typename: 'authStatus',
              status: 'unauthorized',
            },
          },
        });
      }
    });
  }
});

const stateLink = withClientState({
  cache: appCache,
  resolvers: {},
  defaults: {
    authStatus: {
      __typename: 'authStatus',
      status: null,
    },
  },
});

const client = new ApolloClient({
  cache: appCache,
  link: ApolloLink.from([
    errorLink,
    stateLink,
    createUploadLink(),
  ]),
});

export default client;
